<template>
  <svg
    v-if="left||right"
    :class="['v-date-picker__arrow', right && 'v-date-picker__arrow--right']"
    width="27"
    height="33"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.127 11.47L1.26 6.604 6.127 1.74" />
  </svg>
  <svg
    v-else-if="calendar"
    class="v-date-picker__calendar"
    width="18"
    height="18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.125,2.25 L14.0625,2.25 L14.0625,2.25 C13.9589467,2.25 13.8749999,2.16605325 13.8749999,2.0625 C13.8749999,2.0625 13.8749999,2.0625 13.8749999,2.0625 L13.8749999,0.75 L13.8749999,0.75 C13.8749999,0.33578625 13.5392137,-5.64845242e-06 13.125,-5.64845242e-06 C12.7107862,-5.64845242e-06 12.3749999,0.33578625 12.3749999,0.75 L12.3749999,4.3125 L12.3749999,4.3125 C12.3749999,4.6231605 12.1231605,4.875 11.8125,4.875 L11.8125,4.875 L11.8125,4.875 C11.5018395,4.87499999 11.25,4.6231605 11.25,4.3125 C11.25,4.3125 11.25,4.3125 11.25,4.3125 L11.25,2.625 L11.25,2.625 C11.25,2.4178935 11.0821065,2.25 10.8749999,2.25 L6.18749997,2.25 L6.18749996,2.25 C6.08423846,2.25000082 6.00041321,2.16651 5.99999996,2.06325 L5.99999996,0.75 L5.99999996,0.749994352 C5.99999996,0.335780602 5.66421371,-5.64845242e-06 5.24999996,-5.64845242e-06 C4.83578621,-5.64845242e-06 4.49999996,0.335780602 4.49999996,0.749994352 C4.49999996,0.749998117 4.49999996,0.750001883 4.49999996,0.750005648 L4.49999996,4.31250565 L4.49999996,4.31250565 C4.49999996,4.62316615 4.24816046,4.87500565 3.93749996,4.87500565 L3.93749996,4.87500565 L3.93749993,4.87500565 C3.62683943,4.87500563 3.37499987,4.62316615 3.37499987,4.31250565 C3.37499987,4.31250565 3.37499987,4.31250565 3.37499987,4.31250565 L3.37499987,2.62499815 L3.37499987,2.62499815 C3.37499987,2.41789165 3.20710643,2.24999815 2.99999993,2.24999815 C2.99999993,2.24999815 2.99999993,2.24999815 2.99999993,2.24999815 L1.87499987,2.24999815 L1.87499987,2.24999815 C1.04657237,2.24999818 0.374999866,2.9215714 0.374999866,3.74999815 C0.374999866,3.74999815 0.374999866,3.74999815 0.374999866,3.74999815 L0.374999866,16.4999944 L0.374999866,16.4999944 C0.374999866,17.3284254 1.04657237,17.9999944 1.87499987,17.9999944 L16.1249999,17.9999944 L16.1249998,17.9999944 C16.9534273,17.9999944 17.6249998,17.3284254 17.6249998,16.4999944 L17.6249998,3.74999792 L17.6249998,3.74999792 C17.6249998,2.92157042 16.9534273,2.24999792 16.1249998,2.24999792 L16.125,2.25 Z M15.75,16.5000001 L2.25,16.5000001 L2.24999998,16.5000001 C2.04289348,16.5000001 1.87499998,16.3321065 1.87499998,16.125 C1.87499998,16.125 1.87499998,16.125 1.87499998,16.125 L1.87499998,7.125 L1.87499998,7.12500006 C1.87499998,6.91789356 2.04289348,6.75000006 2.24999998,6.75000006 L15.75,6.75000006 L15.75,6.75000006 C15.9571065,6.75000006 16.125,6.91789356 16.125,7.12500006 L16.125,16.1250001 L16.125,16.1250001 C16.125,16.3321066 15.9571065,16.5000001 15.75,16.5000001 C15.75,16.5000001 15.75,16.5000001 15.75,16.5000001 L15.75,16.5000001 Z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    left: {
      type: Boolean,
      default: false
    },
    right: {
      type: Boolean,
      default: false
    },
    calendar: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";

.v-date-picker {
  &__arrow {
    stroke: theme-color("dark");
    stroke-width: 1.75;
    fill: none;
    fill-rule: evenodd;
    stroke-linecap: round;

    &--right {
      transform: rotate(180deg);
    }
  }

  &__calendar {
    fill: theme-color("border");
  }
}
</style>
